<template>
  <v-menu
    ref="menu"
    offset-y
    :close-on-content-click="false"
    min-height="300"
  >
    <template v-slot:activator="{ on }">
      <div class="check-spelling" ref="button">
        <v-badge
          class="check-spelling__badge"
          bordered
          bottom
          overlap
          color="#D64535"
        >
          <template v-slot:badge>
            <v-avatar :style="{width: `${filteredSpellingCheckErrors.length.toString().length*12}px` }">
                  <span v-if="checkingSpellingErrors">
                    <v-icon class="rotating-icon" color="white">sync</v-icon>
                  </span>
              <span v-else>
                    {{ filteredSpellingCheckErrors.length }}
                  </span>
            </v-avatar>
          </template>
          <!-- top relative to quill + half the size of the button - half the margin -->
          <v-btn
            elevation="2"
            fab
            dark
            :color="colorFromSpellingErrorType(filteredSpellingCheckErrors)"
            v-on="on"
          >
            <v-icon>spellcheck</v-icon>
          </v-btn>
        </v-badge>
      </div>
    </template>
    <v-tabs
      :class="'fixed-tabs-bar'"
      v-model="ltActiveTab"
      fixed-tabs
    >
      <v-tab href="#lg-tab-errors">
        {{ $t('message.content.tools.spellcheck.fab.errors') }}
      </v-tab>
      <v-tab href="#lg-tab-dictionary">
        {{ $t('message.content.tools.spellcheck.fab.dictionary') }}
      </v-tab>
      <v-tab-item
        value="lg-tab-errors"
      >
        <v-list
          min-width="200"
        >
          <v-list-tile
            v-for="(check, index) in filteredSpellingCheckErrors"
            :key="index"
            @click="openErrorFromFAB(check)"
          >
            <v-list-tile-title>
              <v-icon :color="colorFromSpellingErrorType([check])">info</v-icon>
              {{ check.context.text.substring(check.context.offset, check.context.offset+check.context.length) }} - {{ check.rule.category.name }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-tab-item>
      <v-tab-item
        value="lg-tab-dictionary"
      >
        <v-card>
          <v-card-text class="quill-spellcheck-dictionary" v-if="personalDictionary.length > 0">
            <v-text-field
              class="quill-spellcheck-dictionary__input"
              v-model="manualFilter"
              :label="$t('message.content.tools.spellcheck.fab.filter')"
              clearable
              color="secondary"
            ></v-text-field>
            <v-list>
              <v-list-tile
                v-for="(word, i) in currentDictionary"
                :key="i"
              >
                <v-list-tile-content>
                  <v-list-tile-title v-html="word"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-icon @click.prevent="removeItemFromDictionary(word)">delete</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-card-text v-else>
            {{ $t('message.content.tools.spellcheck.fab.emptyDictionary') }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat :disabled="removedWords.length === 0" color="secondary" @click.prevent="removedWords = []">
              {{ $t('message.content.tools.spellcheck.fab.undo') }}
            </v-btn>
            <v-btn flat :disabled="removedWords.length === 0" color="secondary" @click.prevent="updateDictionary()">
              {{ $t('message.content.tools.spellcheck.fab.saveChanges') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-menu>
</template>

<script>
import SpellingCheckMixin from '@/components/texteditor/mixins/spelling-check.mixin';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'nx-quill-spelling-check-fab',
  mixins: [SpellingCheckMixin],
  props: {
    checkingSpellingErrors: {
      type: Boolean,
      default: false,
    },
    filteredSpellingCheckErrors: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    manualFilter: null,
    ltActiveTab: null,
    removedWords: [],
  }),
  methods: {
    ...mapActions(
      'staff',
      {
        setManualError: 'SET_MANUAL_ERROR',
      },
    ),
    openErrorFromFAB(check) {
      this.$refs.menu.save();

      // Necesitamos poner a null el valor en la store y en el siguiente tick setearlo al bueno
      // Si lo hacemos directamente no se muestra el menú porque vue no se actualiza
      this.setManualError(null);
      this.$nextTick(() => {
        this.setManualError(check.uuid);
      });
    },
    updateDictionary() {
      this.$emit('updateDictionary', this.currentDictionary);
      this.removedWords = [];
    },
    removeItemFromDictionary(word) {
      this.removedWords.push(word.toLowerCase());
    },
  },
  computed: {
    ...mapGetters('staff', { personalDictionary: 'personalDictionary' }),
    currentDictionary() {
      let dictionary = (this.personalDictionary || [])
        .filter(w => !this.removedWords.includes(w));

      if (this.manualFilter) {
        const manualFilter = this.manualFilter.toLowerCase();
        dictionary = dictionary.filter(w => w.includes(manualFilter));
      }

      return dictionary;
    },
  },
  mounted() {
    // Esto es horrosoro, pero para añadir un border-radius como piden desde diseño no queda otra
    // El elemento es dinámico, lo pinta vue al vuelo, y no podemos simplemente añadirle una clase
    // porque al abrir y cerrar el menú, vuetify las pisa todas, con lo que se pierde
    this.$refs.menu.$refs.content.style = `border-radius: 12px; max-height: 365px; ${this.$refs.menu.$refs.content.style}`;
  },
};
</script>

<style lang="stylus">
.check-spelling__badge .v-badge__badge {
  border: 2px solid white;
  width: fit-content;
  border-radius: 2rem;
  z-index: 999;
}

.v-card__text.quill-spellcheck-dictionary {
  height: 200px;
  overflow-y: scroll;
  padding-top: 44px;
}

.v-card__text .quill-spellcheck-dictionary__input {
  position: absolute;
  top: -4px;
  display: block;
  background-color: #fff;
  width: calc(100% - 44px);
  z-index: 2;
}

.quill-spellcheck-fab-menu {
  border-radius: 12px;
}

.v-tabs.fixed-tabs-bar {
  .v-tabs__bar {
    position: sticky;
    top: 0;
    z-index: 2;
  }

  .v-tabs__slider-wrapper {
    min-width: 80px;
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotating-icon {
  animation: rotating 2s linear infinite;
}
</style>
